import { FunctionComponent } from 'react';
import classnames from 'classnames';

// components
import SearchLayout from '@Components/Layout/Search';
import Alphabet from '@Pages/tra-cuu/benh/Components/Alphabet';
import SearchUI from '@Components/Layout/Search/Components/SearchUI';
import LayoutContainer from '@Components/Layout/Components/Container';
import Breadcrumb, { PathLevelProps } from '@Components/UI/Breadcrumb';
import LayoutResult from '@Components/Layout/Search/Components/LayoutResult';

// Contexts
import { withCategoryStore } from '@Components/Categories/Context';
import { ViewMedia, useViewDetected } from '@Components/Utils/ViewDetected';

// styles
import styles from './Layout.module.scss';

interface LayoutProps {
    keyword?: string;
    onSearch?: (keyword: string) => void;
}

const Layout: FunctionComponent<LayoutProps> = ({ keyword, children, onSearch }) => {
    const { deviceType } = useViewDetected();

    const isMobile = ['mobile', 'tablet'].includes(deviceType);

    const title = keyword ? 'Kết quả tìm kiếm' : 'Tra cứu loại bệnh';
    const subtitle = keyword ? 'Dưới đây là những kết quả phù hợp nhất với từ khóa của bạn.' : 'Hơn 80.000 bệnh phổ biến luôn được cập nhật';

    const paths: Array<PathLevelProps> = [
        {
            label: 'Tra cứu',
            path: '/tra-cuu',
        },
        {
            label: title,
        },
    ];

    const wrapperClassName = classnames([
        styles.wrapper,
        {
            [styles.mobile]: isMobile,
        },
    ]);

    return (
        <SearchLayout onSearch={onSearch} placeholder="Tìm kiếm ngay..." keyword={keyword} className={wrapperClassName}>
            <LayoutContainer className={styles.breadcrumb}>
                <Breadcrumb paths={paths} />
            </LayoutContainer>

            <ViewMedia is={'desktop'}>
                <div className={styles.search_wrapper}>
                    <SearchUI
                        title={title}
                        keyword={keyword}
                        onSearch={onSearch}
                        subTitle={subtitle}
                        className={styles.search}
                        placeholder="Tìm kiếm ngay..."
                        titleClassName={styles?.title}
                        subTitleClassName={styles.sub_title}
                    />
                </div>
            </ViewMedia>

            <ViewMedia is={['mobile', 'tablet']}>
                <div className={styles.header}>
                    <div className={styles.header_title}>{title}</div>
                    <div className={styles.header_description}>{subtitle}</div>
                </div>
            </ViewMedia>

            <div className={styles.alphabet_wrapper}>
                <Alphabet />
            </div>

            <div className={styles.body}>
                <LayoutResult extendComponent={null} formClassName={styles.form} className={styles.layout_view} hasExtendComponent={!isMobile} advisoryClassName={styles.advisory}>
                    {children}
                </LayoutResult>
            </div>
        </SearchLayout>
    );
};

export default withCategoryStore(Layout);
